import { AlertTriangle } from 'lucide-react';

/**
 * L'aveu, a l'ecran, qu'une liste n'est pas complete.
 *
 * POURQUOI IL EXISTE
 *
 * Vingt bornes de lecture vivaient dans le backend, et une seule parlait — a une
 * oreille qui n'ecoutait pas. Une liste amputee presentee comme complete est le
 * defaut le plus couteux du produit : rien, a l'ecran, ne distingue « il n'y en a pas
 * d'autres » de « je ne te montre pas les autres ». L'utilisateur ne peut pas s'en
 * mefier, puisqu'il n'a aucune raison de le soupconner.
 *
 * CE QU'IL DIT, ET COMMENT
 *
 * Il nomme le nombre, il nomme la consequence, et il donne la sortie. Un bandeau qui
 * dirait seulement « resultats tronques » laisserait l'utilisateur sans rien a faire.
 *
 * Il ne s'affiche QUE lorsque la borne a effectivement mordu. Un avertissement
 * permanent s'apprend a ignorer en deux jours, et le jour ou il compte vraiment,
 * plus personne ne le lit.
 */
export default function BandeauTroncature({ etat, quoi = 'resultats', action }) {
  if (!etat?.tronque) return null;

  return (
    <div
      className="flex items-start gap-2.5 px-3 py-2.5 rounded-md border border-amber-300 bg-amber-50 text-amber-900"
      role="status"
      data-testid="bandeau-troncature"
    >
      <AlertTriangle className="w-4 h-4 mt-0.5 shrink-0 text-amber-600" aria-hidden />
      <div className="text-[12.5px] leading-snug">
        <p className="font-semibold">
          Cette liste est incomplete : seuls les {etat.borne} premiers {quoi} sont
          affiches.
        </p>
        <p className="text-amber-800">
          {action
            || `Affinez les filtres pour reduire le nombre de ${quoi}, ou utilisez l'export pour obtenir la totalite.`}
        </p>
      </div>
    </div>
  );
}
